// extracted by mini-css-extract-plugin
export default {"Front":"Front_Front__r4DYA","theme-light":"Front_theme-light__ULzVR","theme-dark":"Front_theme-dark__ml8hx","CardImgWrapper":"Front_CardImgWrapper__IkvsN","test":"Front_test__5Ca7x"};